import { render, staticRenderFns } from "./ChamCong.vue?vue&type=template&id=303dfa8c"
import script from "./ChamCong.vue?vue&type=script&lang=js"
export * from "./ChamCong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports